import moment from 'moment';

const isFulfillmentTimeOutOfRange = (preparedByTime, currentPrepTime) => {
  if (!preparedByTime || !currentPrepTime) {
    return false;
  }
  const nowAtLocationUTC = moment.utc();
  const startOfPrepTimeUTC = moment
    .utc(preparedByTime)
    .subtract(currentPrepTime, 'minutes');

  return nowAtLocationUTC >= startOfPrepTimeUTC;
};

export default isFulfillmentTimeOutOfRange;
